"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBButton = _interopRequireDefault(require("../HBButton/HBButton"));
var ToastActions = function ToastActions(_ref) {
  var actions = _ref.actions,
    onActionClick = _ref.onActionClick;
  return /*#__PURE__*/_react["default"].createElement(ActionsContainer, null, actions.map(function (action) {
    return /*#__PURE__*/_react["default"].createElement(_HBButton["default"], {
      buttonTheme: action.theme,
      customTheme: action.customTheme,
      key: action.text,
      onClick: function onClick() {
        return onActionClick(action);
      },
      size: action.size,
      testId: action.testIdName ? "hb-toast-".concat(action.testIdName, "-action--button") : undefined,
      testIdType: "hb-toast-action--button"
    }, action.text);
  }));
};
var _default = exports["default"] = ToastActions; // -------------------------------- Styles -------------------------------- //
var ActionsContainer = _styledComponents["default"].div.withConfig({
  displayName: "ToastActions__ActionsContainer",
  componentId: "sc-27s679-0"
})(["display:flex;gap:12px;"]);
//# sourceMappingURL=ToastActions.js.map